import { render, staticRenderFns } from "./EarlyAccountSuggest.vue?vue&type=template&id=5861dd62"
import script from "./EarlyAccountSuggest.vue?vue&type=script&lang=js"
export * from "./EarlyAccountSuggest.vue?vue&type=script&lang=js"
import style0 from "./EarlyAccountSuggest.vue?vue&type=style&index=0&id=5861dd62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports